const WellnessTab = ({ wellness }) => {
  if (!wellness) return null

  return (
    <div className="overflow-x-auto">
      <h3 className="text-xl font-semibold text-white mb-6">
        Wellness Collaborative Submissions ({wellness.length})
      </h3>
      <table className="min-w-full divide-y divide-white/10">
        <thead>
          <tr>
            {['Facilitator', 'Email', 'Join Frequency', 'Founding Member', 'Festival Interest', 'Session Focus', 'Date'].map(header => (
              <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {wellness.map((item) => (
            <tr key={item.id} className="hover:bg-white/5">
              <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-white">
                {item.facilitator.name}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.facilitator.email}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300 capitalize">
                {item.submissionData.joinFrequency}
                {item.submissionData.joinFrequency === 'others' && item.submissionData.joinFrequencyOther && 
                  `: ${item.submissionData.joinFrequencyOther}`}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300 capitalize">
                {item.submissionData.foundingMemberBandwidth}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.submissionData.festivalInterest}
                {item.submissionData.festivalInterest === 'other' && item.submissionData.festivalInterestOther &&
                  `: ${item.submissionData.festivalInterestOther}`}
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.submissionData.sessionFocus}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {new Date(item.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default WellnessTab
